export * from './ImportsModule'
export const importsPath = '/et/company/:companyId/importsModule'
